import { cn } from '@/lib/utils';

interface LightLogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeMap = {
  sm: 'text-lg',
  md: 'text-xl',
  lg: 'text-2xl',
};

export const LightLogo = ({ size = 'md', className }: LightLogoProps) => {
  return (
    <span className={cn('font-bold', sizeMap[size], className)}>
      <span className="text-slate-900">Faceless Aura</span>{' '}
      <span className="text-blue-600">Club</span>
    </span>
  );
};

export default LightLogo;
